var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { HomepageHeroAngledContainer } from './HomepageHeroAngledContainer';
import parse from 'html-react-parser';
import { Button } from '../../components/CtaButtons';
import gsap from 'gsap';
import './HomepageHeroText.scss';
import pattern from '../../assets/images/HomepageHero/pattern.png';
export var HomepageHeroText = function (_a) {
    var homepage_data = _a.data.homepage_data, internalRef = _a.internalRef;
    var angles = useMemo(function () {
        var angleObject = {
            topLeftInit: 0,
            topLeftEnd: 0,
            topRightInit: 100,
            topRightEnd: 0,
            bottomRightInit: 100,
            bottomRightEnd: 100,
            bottomLeftInit: 0,
            bottomLeftEnd: 89,
        };
        return angleObject;
    }, []);
    useEffect(function () {
        var tl = gsap.timeline();
        tl.to('.homepage-hero-text-anime', {
            autoAlpha: 1,
            duration: 1,
            stagger: {
                each: 0.5,
            },
            delay: 0.5,
        });
    }, []);
    var ctaButton = (_jsx("div", __assign({ className: "text-enblue-500", style: { zIndex: 1 } }, { children: homepage_data.cta_copy }), void 0));
    return (_jsxs("div", __assign({ ref: internalRef, className: "homepage-hero-angled-container-block text-white relative w-full snap-center " }, { children: [_jsx(HomepageHeroAngledContainer, __assign({ className: "homepage-hero-angled-container-stripe absolute h-full w-full ", background: homepage_data.diagonal_strip_color }, angles), void 0),
            _jsxs(HomepageHeroAngledContainer, __assign({ className: "absolute top-0 left-0 h-full w-full flex justify-center items-center", background: "#0074bd" }, angles, { children: [_jsxs("div", __assign({ className: "homepage-hero-text-anime", style: { visibility: 'hidden' } }, { children: [_jsx("div", __assign({ className: "homepage-hero-headline font-light text-center text-[32px] leading-[1.25] md:text-[40px] lg:w-[793px] lg:text-[56px] lg:leading-[1.14]" }, { children: parse(homepage_data.headline) }), void 0),
                            homepage_data.sub_text && (_jsx("div", __assign({ className: "homepage-hero-subtext" }, { children: parse(homepage_data.sub_text) }), void 0)),
                            homepage_data.cta_link && homepage_data.cta_copy && (_jsx("a", __assign({ className: "homepage-hero-button-link", href: homepage_data.cta_link }, { children: _jsx(Button, __assign({ classes: [
                                        'text-enblue-500',
                                        'focus:bg-enblue-light',
                                        'ArticleButtons_custom',
                                        'homepage-hero-cta-button',
                                    ], animate: "animate-white" }, { children: ctaButton }), void 0) }), void 0))] }), void 0),
                    _jsx("img", { src: pattern, alt: "static background image", className: "absolute top-0 left-0 h-full w-full flex justify-center items-center pattern-image" }, void 0)] }), void 0)] }), void 0));
};
